Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReply
  constructor: (builder) ->
    @text = builder.getText()
    @createdAt = builder.getCreatedAt()
    @contentId = builder.getContentId()
    @reviewSnapshot = builder.getReviewSnapshot()

  getText: =>
    @text

  getCreatedAt: =>
    @createdAt

  getContentId: =>
    @contentId

  getReviewSnapshot: =>
    @reviewSnapshot
